import { render, staticRenderFns } from "./NotifyGroupWizard.vue?vue&type=template&id=352bb30c&scoped=true&"
import script from "./NotifyGroupWizard.vue?vue&type=script&lang=js&"
export * from "./NotifyGroupWizard.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./NotifyGroupWizard.vue?vue&type=style&index=1&id=352bb30c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352bb30c",
  null
  
)

export default component.exports